/* eslint-disable unicorn/prevent-abbreviations */
import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import type { Slots } from 'vue'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
export interface DefinesVisibility {
  visible?: boolean | undefined | ((item: unknown) => boolean)
}

export function isVisible(item: DefinesVisibility): boolean {
  if (item.visible === undefined) {
    return true
  }

  if (typeof item.visible === 'function') {
    return item.visible(item)
  }

  return item.visible
}

export function hasSlot(slotName: string, slots: Slots) {
  const slot = slots[slotName as string]
  if (!slot) return false

  const nodes = slot()
  if (!nodes) return false

  const node = nodes[`0`]
  if (!node) return false

  return Number(node.children?.length) > 0
}

export function isMac() {
  return /mac|iphone|ipod|ipad/i.test(navigator.userAgent)
}

export function isMobile() {
  const toMatch = [/android/i, /webos/i, /iphone/i, /ipad/i, /ipod/i, /blackberry/i, /windows phone/i]

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem)
  })
}

export function sleep(milliseconds: number) {
  return new Promise((resolve) => setTimeout(resolve, milliseconds))
}
